import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const SourceDataTab = ({ previewRows, previewColumns, mappedColumnsSet, getRowClassName }) => {
    return (
        <div style={{ fontSize: '0.9rem' }}>
            <div style={{ overflowX: 'auto', minHeight: '20vh', maxHeight: '61vh', overflowY: 'auto' }}>
                <DataTable
                    value={previewRows}
                    scrollable
                    scrollHeight="400px"
                    style={{
                        fontSize: '0.9em',
                        padding: 0,
                        margin: 0,
                        lineHeight: 1.2,
                        minWidth: 'max-content',
                    }}
                    showGridlines
                    rowClassName={getRowClassName(previewRows)}
                >
                    {previewColumns
                        .filter(col => !(typeof col === 'string' && col.startsWith('=')))
                        .map(col => (
                            <Column
                                key={col}
                                field={col}
                                header={
                                    mappedColumnsSet.has(col)
                                        ? (
                                            <span
                                                style={{
                                                    background: '#d4edda',
                                                    color: '#155724',
                                                    padding: '2px 8px',
                                                    borderRadius: 4,
                                                    fontWeight: 600,
                                                    fontSize: '0.95em',
                                                }}
                                            >
                                                {col}
                                            </span>
                                        )
                                        : (
                                            <span
                                                style={{
                                                    background: '#f8d7da',
                                                    color: '#721c24',
                                                    padding: '2px 8px',
                                                    borderRadius: 4,
                                                    fontWeight: 600,
                                                    fontSize: '0.95em',
                                                }}
                                            >
                                                {col}
                                            </span>
                                        )
                                }
                                style={{ minWidth: 120, padding: '2px 4px' }}
                                headerStyle={{ padding: '2px 4px' }}
                            />
                        ))}
                </DataTable>
            </div>
        </div>
    );
};

export default SourceDataTab;